export const HEALTH_REASON_CODE_BY_RUNTIME_STATE = {
    healthy: "health.ok",
    idle: "health.idle",
    suspect: "health.suspect",
    down: "health.down",
};
export const HEARTBEAT_POLICY_DEFAULTS = {
    watchdogTimeoutMs: 45_000,
    heartbeatIdleIntervalMs: 60_000,
    heartbeatSuspectIntervalMs: 15_000,
    suspectAfterMissed: 1,
    downAfterMissed: 2,
    reconnectBackoffMs: [1000, 2000, 5000, 10_000, 30_000],
};
export const mapRuntimeHealthToExternalHealth = (state) => {
    if (state === "down") {
        return "down";
    }
    if (state === "suspect") {
        return "degraded";
    }
    return "ok";
};
export const resolveHealthReasonCode = (state) => HEALTH_REASON_CODE_BY_RUNTIME_STATE[state];
export const isHealthReasonCodeConsistent = (input) => mapRuntimeHealthToExternalHealth(input.runtimeState) ===
    input.externalState &&
    resolveHealthReasonCode(input.runtimeState) === input.reasonCode;
export const heartbeatSentCountPerMinute = (intervalMs) => {
    if (intervalMs <= 0) {
        throw new Error("intervalMs must be greater than 0");
    }
    return 60_000 / intervalMs;
};
export const reconnectSuccessRate = (successes, attempts) => {
    if (attempts <= 0) {
        return 1;
    }
    return successes / attempts;
};
export const suspectTransitionRatePerMinute = (transitions, durationSeconds) => {
    if (durationSeconds <= 0) {
        throw new Error("durationSeconds must be greater than 0");
    }
    return transitions / (durationSeconds / 60);
};
